/* ============================================================
   CUSTOM JS — N'GO SHOES
   Thème : Wellina (Custom from Wellina by Komunic)

   Toutes les personnalisations JS vont ici.
   Chaque bloc doit être encadré par :
     // CUSTOM:start — description
     // CUSTOM:end
   ============================================================ */

// CUSTOM:start — Cart drawer : clic card = ajout panier (via submit natif du thème)
document.addEventListener('click', function(e) {
  var card = e.target.closest('.cart-drawer__recommendation-product .product-card');
  if (!card) return;

  e.preventDefault();
  e.stopPropagation();

  // Cherche le formulaire d'ajout au panier dans la card
  var form = card.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  var variantInput = form.querySelector('input[name="id"]');
  if (!variantInput || variantInput.disabled) return;

  // Loader visuel sur la card
  card.style.opacity = '0.5';
  card.style.pointerEvents = 'none';
  card.style.transition = 'opacity 0.2s';

  // Restaure après l'ajout (succès ou échec)
  var restore = function() {
    card.style.opacity = '';
    card.style.pointerEvents = '';
  };
  document.addEventListener('cart:added', restore, { once: true });
  document.addEventListener('fox-theme:cart:added', restore, { once: true });
  // Fallback timeout au cas où l'event n'arrive pas
  setTimeout(restore, 3000);

  // Utilise requestSubmit pour déclencher le handler natif de product-form-component
  var submitBtn = form.querySelector('button[type="submit"]');
  if (submitBtn) {
    submitBtn.disabled = false;
    form.requestSubmit(submitBtn);
  }
}, true);
// CUSTOM:end

// CUSTOM:start — Aperçu image du coloris au survol (catalogue)
// Au survol d'un swatch couleur, affiche la 1re photo du produit de ce coloris
// par-dessus l'image de la carte ; restaure quand on quitte la rangée.
(function () {
  function previewFor(swatch) {
    var media = swatch.closest('.product-card__media');
    return media ? media.querySelector('.color-swatch-preview') : null;
  }

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest && e.target.closest('.color-swatch-linked[data-swatch-image]');
    if (!swatch) return;
    var src = swatch.getAttribute('data-swatch-image');
    if (!src) return;
    var preview = previewFor(swatch);
    if (!preview) return;
    if (preview.getAttribute('src') !== src) {
      preview.setAttribute('src', src);
    }
    preview.classList.add('is-visible');
  });

  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest && e.target.closest('.color-swatch-linked[data-swatch-image]');
    if (!swatch) return;
    var row = swatch.closest('.color-swatches-overlay');
    var to = e.relatedTarget;
    // On reste dans la rangée de swatches : ne pas masquer (le prochain survol mettra à jour)
    if (to && to.closest && row && to.closest('.color-swatches-overlay') === row) return;
    var preview = previewFor(swatch);
    if (preview) preview.classList.remove('is-visible');
  });
})();
// CUSTOM:end

// CUSTOM:start — Déploiement des coloris supplémentaires (catalogue)
// Clic sur "+X" : affiche les couleurs masquées et active le scroll horizontal
document.addEventListener('click', function (e) {
  var more = e.target.closest && e.target.closest('.color-swatch-more');
  if (!more) return;
  e.preventDefault();
  var row = more.closest('.color-swatches-linked--catalog');
  if (!row) return;
  row.classList.add('is-expanded');
  more.setAttribute('hidden', '');
});
// CUSTOM:end

// CUSTOM:start — Produits complémentaires : ajout groupé au panier
// Au submit du formulaire produit : on ajoute d'abord les add-ons cochés via
// /cart/add.js, puis on relance le submit natif (ajout du produit principal +
// ouverture du tiroir, qui reflète alors tout le panier).
(function () {
  var pending = new WeakSet(); // formulaires déjà traités (2e passe)

  function addonsForForm(form) {
    var pfc = form.closest('product-form-component');
    var pid = pfc && pfc.getAttribute('data-product-id');
    if (!pid) return [];
    var container = document.querySelector('.product-addons[data-product-id="' + pid + '"]');
    if (!container) return [];
    var items = [];
    container.querySelectorAll('.product-addon__toggle:checked').forEach(function (cb) {
      var id = cb.getAttribute('data-variant-id');
      if (id) items.push({ id: Number(id), quantity: 1 });
    });
    return items;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;

    // 2e passe (add-ons déjà ajoutés) : on laisse le thème faire l'ajout natif
    if (pending.has(form)) {
      pending.delete(form);
      return;
    }

    var items = addonsForForm(form);
    if (!items.length) return; // aucun add-on coché → comportement natif normal

    // On bloque l'ajout natif le temps d'ajouter les add-ons
    e.preventDefault();
    e.stopImmediatePropagation();

    var resubmit = function () {
      pending.add(form);
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = false;
      form.requestSubmit(btn || undefined);
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(resubmit)
      .catch(resubmit); // même en cas d'échec, on ajoute au moins le produit principal
  }, true);
})();
// CUSTOM:end

// CUSTOM:start — Cloche de notifications N'GO
(function () {
  if (window.customElements && customElements.get('notifications-bell')) return;
  var SEEN_KEY = 'ngo_notif_seen';

  function readSeen() {
    try { return JSON.parse(localStorage.getItem(SEEN_KEY)) || []; }
    catch (e) { return []; }
  }
  function writeSeen(ids) {
    try { localStorage.setItem(SEEN_KEY, JSON.stringify(ids)); } catch (e) {}
  }

  class NotificationsBell extends HTMLElement {
    connectedCallback() {
      this.bell = this.querySelector('[data-notif-toggle]');
      this.panel = this.querySelector('#ngo-notif-panel');
      this.countEl = this.querySelector('[data-notif-count]');
      this.listView = this.querySelector('[data-notif-list]');
      this.ids = (this.getAttribute('data-notif-ids') || '').split(',').filter(Boolean);
      this.isOpen = false;
      if (!this.bell || !this.panel) return;

      this._onDocClick = this.onDocClick.bind(this);
      this._onKey = this.onKey.bind(this);
      this.bell.addEventListener('click', this.toggle.bind(this));
      this.addEventListener('click', this.onClick.bind(this));

      this.updateCount();
    }

    updateCount() {
      var seen = readSeen();
      var unread = this.ids.filter(function (id) { return seen.indexOf(id) === -1; });
      var n = unread.length;
      if (n > 0) {
        this.countEl.textContent = n > 9 ? '9+' : String(n);
        this.countEl.hidden = false;
        this.bell.setAttribute('aria-label', 'Notifications, ' + n + ' non lues');
      } else {
        this.countEl.hidden = true;
        this.bell.setAttribute('aria-label', 'Notifications');
      }
    }

    markAllSeen() {
      var merged = readSeen().slice();
      this.ids.forEach(function (id) { if (merged.indexOf(id) === -1) merged.push(id); });
      writeSeen(merged);
      this.updateCount();
    }

    toggle(e) {
      e.preventDefault();
      this.isOpen ? this.close() : this.openPanel();
    }

    openPanel() {
      this.showList();
      this.panel.hidden = false;
      this.isOpen = true;
      this.bell.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this._onDocClick, true);
      document.addEventListener('keydown', this._onKey);
      this.markAllSeen();
      var first = this.panel.querySelector('button, a, input');
      if (first) first.focus();
    }

    close() {
      this.panel.hidden = true;
      this.isOpen = false;
      this.bell.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this._onDocClick, true);
      document.removeEventListener('keydown', this._onKey);
      this.bell.focus();
    }

    showList() {
      if (this.listView) this.listView.hidden = false;
      this.querySelectorAll('[data-notif-detail]').forEach(function (d) { d.hidden = true; });
    }

    showDetail(id) {
      if (this.listView) this.listView.hidden = true;
      this.querySelectorAll('[data-notif-detail]').forEach(function (d) {
        d.hidden = d.getAttribute('data-notif-detail') !== id;
      });
      var active = this.querySelector('[data-notif-detail="' + id + '"]');
      if (active) {
        var f = active.querySelector('button, a, input');
        if (f) f.focus();
      }
    }

    onClick(e) {
      var openBtn = e.target.closest('[data-notif-open]');
      if (openBtn) { e.preventDefault(); this.showDetail(openBtn.getAttribute('data-notif-open')); return; }
      if (e.target.closest('[data-notif-back]')) { e.preventDefault(); this.showList(); return; }
      if (e.target.closest('[data-notif-close]')) { e.preventDefault(); this.close(); return; }
    }

    onDocClick(e) {
      if (!this.contains(e.target)) this.close();
    }

    onKey(e) {
      if (e.key === 'Escape') this.close();
    }
  }

  if (window.customElements) {
    customElements.define('notifications-bell', NotificationsBell);
  }
})();
// CUSTOM:end

// CUSTOM:start — Grille catégorie : scroll horizontal pinné (> 4 éléments)
(function () {
  var mqDesktop = window.matchMedia('(min-width: 750px)');
  var mqMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var instances = [];

  function px(v) { var n = parseFloat(v); return isNaN(n) ? 0 : n; }
  function headerH() {
    return px(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
  }
  function pinActive() { return mqDesktop.matches && !mqMotion.matches; }

  function CatHScroll(section) {
    this.section = section;
    this.track = section.querySelector('.cat-grid__track');
    this.stage = section.querySelector('.cat-grid__stage');
    this.items = section.querySelector('.cat-grid__items');
    this.cpv = parseInt(section.getAttribute('data-cards-per-view'), 10) || 4;
    this.distance = 0;
    this.raf = null;
    this.onScroll = this.onScroll.bind(this);
  }

  CatHScroll.prototype.measure = function () {
    if (!this.track || !this.stage || !this.items) return;
    if (!pinActive()) { this.reset(); return; }

    var styles = getComputedStyle(this.items);
    var gap = px(styles.columnGap) || px(styles.gap);
    var w = (this.stage.clientWidth - (this.cpv - 1) * gap) / this.cpv;
    if (w > 0) {
      this.section.style.setProperty('--cat-card-w', w + 'px');
    }
    this.distance = Math.max(0, this.items.scrollWidth - this.stage.clientWidth);
    this.track.style.setProperty('--cat-track-h', (this.stage.offsetHeight + this.distance) + 'px');
    this.update();
  };

  CatHScroll.prototype.update = function () {
    if (!pinActive() || this.distance <= 0) {
      if (this.items) this.items.style.transform = '';
      return;
    }
    var top = this.track.getBoundingClientRect().top;
    var progress = (headerH() - top) / this.distance;
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;
    this.items.style.transform = 'translate3d(' + (-progress * this.distance) + 'px, 0, 0)';
  };

  CatHScroll.prototype.onScroll = function () {
    if (this.raf) return;
    var self = this;
    this.raf = requestAnimationFrame(function () { self.raf = null; self.update(); });
  };

  CatHScroll.prototype.reset = function () {
    this.section.style.removeProperty('--cat-card-w');
    if (this.track) this.track.style.removeProperty('--cat-track-h');
    if (this.items) this.items.style.transform = '';
  };

  function initAll() {
    instances = Array.prototype.map.call(
      document.querySelectorAll('[data-hscroll]'),
      function (s) { return new CatHScroll(s); }
    );
    instances.forEach(function (i) {
      window.addEventListener('scroll', i.onScroll, { passive: true });
      i.measure();
    });
  }
  function remeasureAll() { instances.forEach(function (i) { i.measure(); }); }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }

  var resizeT;
  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(remeasureAll, 150);
  }, { passive: true });
  window.addEventListener('load', remeasureAll);
  if (mqDesktop.addEventListener) {
    mqDesktop.addEventListener('change', remeasureAll);
    mqMotion.addEventListener('change', remeasureAll);
  }
})();
// CUSTOM:end

// CUSTOM:start — Grille catégorie : carrousel à flèches discrètes
(function () {
  function initCarousel(section) {
    if (section.__catCarousel) return;
    section.__catCarousel = true;

    var viewport = section.querySelector('.cat-grid__viewport');
    var items = section.querySelector('.cat-grid__items');
    var prev = section.querySelector('.cat-grid__arrow--prev');
    var next = section.querySelector('.cat-grid__arrow--next');
    if (!viewport || !items) return;

    var stepMode = section.getAttribute('data-carousel-step') || 'page';

    function cardStep() {
      var card = items.querySelector('.cat-grid__card');
      if (!card) return viewport.clientWidth;
      var styles = getComputedStyle(items);
      var gap = parseFloat(styles.columnGap) || parseFloat(styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function clamp(x) {
      return Math.max(0, Math.min(viewport.scrollWidth - viewport.clientWidth, x));
    }

    // Largeur d'une « page » = pas de défilement (1 carte en mode « one »,
    // sinon le nombre de colonnes visibles → swipe N par N).
    function pageWidth() {
      var step = cardStep();
      if (stepMode === 'one') return step;
      var n = Math.max(1, Math.round(viewport.clientWidth / step));
      return step * n;
    }

    function update() {
      var max = viewport.scrollWidth - viewport.clientWidth - 1;
      var overflow = max > 1;
      section.classList.toggle('is-static', !overflow);
      if (prev) prev.classList.toggle('is-disabled', viewport.scrollLeft <= 1);
      if (next) next.classList.toggle('is-disabled', viewport.scrollLeft >= max);
    }

    var motionId = null;
    function stopMotion() { if (motionId) { cancelAnimationFrame(motionId); motionId = null; } }
    // pendant les manipulations JS : on coupe le snap + le smooth (sinon ça « saute »)
    function setFree(on) {
      viewport.style.scrollSnapType = on ? 'none' : '';
      viewport.style.scrollBehavior = on ? 'auto' : '';
    }

    // Défilement animé (easing) vers une position précise
    function animateTo(target, duration) {
      stopMotion();
      target = clamp(target);
      var start = viewport.scrollLeft;
      var dist = target - start;
      if (Math.abs(dist) < 1) { setFree(false); update(); return; }
      duration = duration || 420;
      var t0 = null;
      setFree(true);
      function frame(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / duration);
        var e = 1 - Math.pow(1 - p, 3); // easeOutCubic
        viewport.scrollLeft = start + dist * e;
        if (p < 1) { motionId = requestAnimationFrame(frame); }
        else { motionId = null; setFree(false); update(); }
      }
      motionId = requestAnimationFrame(frame);
    }

    // Va à la page voisine (flèches) en restant aligné sur la grille de pages
    function go(dir) {
      var pw = pageWidth();
      var base = Math.round(viewport.scrollLeft / pw);
      animateTo((base + dir) * pw);
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    var raf = null;
    viewport.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; update(); });
    }, { passive: true });

    /* ----- Glisser-déposer à la souris (le tactile garde le scroll natif) ----- */
    var down = false, startX = 0, startLeft = 0, moved = false, suppressClick = false;

    // Au relâcher : on se cale sur la page la plus proche, avec garantie d'avancer
    // d'au moins une page dans le sens du glissé si le seuil est franchi.
    function snapToPage() {
      var pw = pageWidth();
      var basePage = Math.round(startLeft / pw);
      var dragged = viewport.scrollLeft - startLeft;
      var dir = dragged > 0 ? 1 : -1;
      var threshold = Math.min(pw * 0.15, 60); // sensibilité du swipe
      var nearest = Math.round(viewport.scrollLeft / pw);
      if (Math.abs(dragged) > threshold) {
        if (dir > 0 && nearest <= basePage) nearest = basePage + 1;
        if (dir < 0 && nearest >= basePage) nearest = basePage - 1;
      }
      animateTo(nearest * pw);
    }

    function endDrag(doSnap) {
      if (!down) return;
      down = false;
      viewport.classList.remove('is-grabbing');
      if (doSnap && moved) {
        suppressClick = true;
        setTimeout(function () { suppressClick = false; }, 0);
        snapToPage();
      } else { setFree(false); }
    }

    // Les liens <a> sont « draggables » nativement : on coupe ce drag natif
    // (sinon il déclenche un pointercancel et notre défilement ne démarre pas)
    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // tactile = scroll natif
      if (e.button !== 0) return;            // bouton gauche uniquement
      stopMotion();
      down = true; moved = false;
      startX = e.clientX; startLeft = viewport.scrollLeft;
      // PAS de capture ici : sinon le click serait redirigé vers le viewport (Chrome)
      // et la carte ne serait plus cliquable. On capture seulement au vrai glissement.
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 3) {
        moved = true;
        setFree(true);
        viewport.classList.add('is-grabbing');
        try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (moved) {
        e.preventDefault(); // bloque la sélection de texte / drag natif
        viewport.scrollLeft = clamp(startLeft - dx);
      }
    });
    // up = on relâche (avec inertie) ; cancel / perte de capture = on stoppe net
    viewport.addEventListener('pointerup', function () { endDrag(true); });
    viewport.addEventListener('pointercancel', function () { endDrag(false); });
    viewport.addEventListener('lostpointercapture', function () { endDrag(false); });
    // Empêche de suivre le lien d'une carte juste après un glissement
    viewport.addEventListener('click', function (e) {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(update, 150);
    }, { passive: true });
    window.addEventListener('load', update);

    update();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-carousel]'),
      initCarousel
    );
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }

  // Aperçu / éditeur de thème : ré-init quand une section est (re)chargée
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) {
      e.target.__catCarousel = false;
      initAll(e.target);
    }
  });
})();
// CUSTOM:end

// CUSTOM:start — Galerie produit : clic sur l'image => ouverture du zoom plein écran (lightbox natif)
(function () {
  document.addEventListener('click', function (e) {
    // déjà géré nativement, ou éléments à ne pas détourner (miniatures, contrôles, liens/boutons)
    if (e.target.closest('.zoom-dialog-button')) return;
    if (e.target.closest('.carousel__thumbnail, .media-gallery__grid-thumbnails, .media-gallery__carousel-thumbnails')) return;
    if (e.target.closest('a, button, [role="button"], input, label')) return;

    // uniquement les images de la galerie produit principale
    var item = e.target.closest('.media-gallery--main .media-gallery__item');
    if (!item) return;

    var btn = item.querySelector('.zoom-dialog-button');
    if (!btn) return;

    e.preventDefault();
    btn.click(); // déclenche le lightbox plein écran natif (photoswipe)
  });
})();
// CUSTOM:end

// CUSTOM:start — Galerie produit N'GO : slider du carrousel ".ngo-gallery__rest"
// (flèches précédent/suivant + glisser-déposer souris + molette verticale -> horizontal)
(function () {
  function makeArrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ngo-gallery__nav ngo-gallery__nav--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Photos précédentes' : 'Photos suivantes');
    var d = dir === 'prev' ? 'M12.5 4.5 7 10l5.5 5.5' : 'M7.5 4.5 13 10l-5.5 5.5';
    b.innerHTML = '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">' +
      '<path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  function initRest(rest) {
    if (rest.dataset.ngoSlider) return;
    rest.dataset.ngoSlider = '1';

    // Conteneur relatif autour du carrousel pour positionner les flèches
    var wrap = document.createElement('div');
    wrap.className = 'ngo-gallery__rest-wrap';
    rest.parentNode.insertBefore(wrap, rest);
    wrap.appendChild(rest);

    var prev = makeArrow('prev');
    var next = makeArrow('next');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function step() {
      var item = rest.querySelector('.ngo-gallery__rest-item');
      var s = getComputedStyle(rest);
      var gap = parseFloat(s.columnGap) || parseFloat(s.gap) || 0;
      return item ? item.getBoundingClientRect().width + gap : rest.clientWidth * 0.8;
    }

    var rafId = null;
    function update() {
      rafId = null;
      var max = rest.scrollWidth - rest.clientWidth - 1;
      wrap.classList.toggle('ngo-gallery--has-nav', max > 0);
      prev.disabled = rest.scrollLeft <= 0;
      next.disabled = rest.scrollLeft >= max;
    }
    function scheduleUpdate() {
      if (rafId) return;
      rafId = requestAnimationFrame(update);
    }

    var clamp = function (x) {
      return Math.max(0, Math.min(rest.scrollWidth - rest.clientWidth, x));
    };

    // Désactive le scroll-snap pendant les animations JS (sinon ça « saute »)
    var motionId = null;
    function stopMotion() {
      if (motionId) { cancelAnimationFrame(motionId); motionId = null; }
    }
    function setFree(on) {
      rest.style.scrollSnapType = on ? 'none' : '';
    }

    // Défilement animé avec easing (flèches)
    function animateTo(target, duration) {
      stopMotion();
      target = clamp(target);
      var start = rest.scrollLeft;
      var dist = target - start;
      if (!dist) return;
      duration = duration || 480;
      var t0 = null;
      setFree(true);
      function frame(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / duration);
        var e = 1 - Math.pow(1 - p, 3); // easeOutCubic
        rest.scrollLeft = start + dist * e;
        if (p < 1) {
          motionId = requestAnimationFrame(frame);
        } else {
          motionId = null;
          setFree(false);
          update();
        }
      }
      motionId = requestAnimationFrame(frame);
    }

    prev.addEventListener('click', function () { animateTo(rest.scrollLeft - step()); });
    next.addEventListener('click', function () { animateTo(rest.scrollLeft + step()); });
    rest.addEventListener('scroll', scheduleUpdate, { passive: true });

    // Inertie après le glisser
    function momentum(velocity) {
      var v = velocity; // px par frame
      function frame() {
        v *= 0.93; // friction
        var nl = rest.scrollLeft + v;
        if (Math.abs(v) < 0.4 || nl <= 0 || nl >= rest.scrollWidth - rest.clientWidth) {
          rest.scrollLeft = clamp(nl);
          motionId = null;
          setFree(false);
          update();
          return;
        }
        rest.scrollLeft = nl;
        motionId = requestAnimationFrame(frame);
      }
      if (Math.abs(v) > 1) {
        setFree(true);
        motionId = requestAnimationFrame(frame);
      }
    }

    // Glisser-déposer à la souris (le tactile garde le scroll natif)
    var down = false, startX = 0, startLeft = 0, moved = false, suppressClick = false;
    var lastX = 0, lastT = 0, vel = 0;
    rest.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      stopMotion();
      setFree(true);
      down = true; moved = false;
      startX = lastX = e.clientX; startLeft = rest.scrollLeft;
      lastT = e.timeStamp; vel = 0;
      rest.classList.add('is-grabbing');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      rest.scrollLeft = clamp(startLeft - dx);
      var dt = e.timeStamp - lastT;
      if (dt > 0) vel = -(e.clientX - lastX) / dt * 16; // px/frame (sens du scroll)
      lastX = e.clientX; lastT = e.timeStamp;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      rest.classList.remove('is-grabbing');
      if (moved) {
        suppressClick = true;
        setTimeout(function () { suppressClick = false; }, 0);
        momentum(vel);
      } else {
        setFree(false);
      }
    });
    // Empêche l'ouverture du zoom juste après un glissement (handler zoom = doc bubble)
    rest.addEventListener('click', function (e) {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    update();
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('load', scheduleUpdate);
  }

  function initAll() {
    document.querySelectorAll('.ngo-gallery__rest').forEach(initRest);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
// CUSTOM:end

// CUSTOM:start — Galerie produit N'GO : points de pagination (mobile, 1 image par vue)
// Sur mobile, le wrapper de la galerie est un carrousel plein écran (voir custom.css).
// On génère un point par image et on synchronise le point actif au défilement.
(function () {
  function initDots(gallery) {
    if (gallery.dataset.ngoDots) return;
    var wrapper = gallery.querySelector('.ngo-gallery__wrapper');
    if (!wrapper) return;
    // Items dans l'ordre du DOM : 2 premières (__top) puis le reste (__rest)
    var items = gallery.querySelectorAll('.ngo-gallery__top-item, .ngo-gallery__rest-item');
    if (items.length < 2) return; // 0 ou 1 image : pas de carrousel
    gallery.dataset.ngoDots = '1';

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'ngo-gallery__dots';
    var dots = [];
    for (var i = 0; i < items.length; i++) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'ngo-gallery__dot';
      d.setAttribute('aria-label', 'Photo ' + (i + 1));
      (function (idx) {
        d.addEventListener('click', function () {
          wrapper.scrollTo({ left: idx * wrapper.clientWidth, behavior: 'smooth' });
        });
      })(i);
      dotsWrap.appendChild(d);
      dots.push(d);
    }
    wrapper.parentNode.insertBefore(dotsWrap, wrapper.nextSibling);

    var raf = null;
    function setActive() {
      raf = null;
      var w = wrapper.clientWidth || 1;
      var idx = Math.round(wrapper.scrollLeft / w);
      if (idx < 0) idx = 0;
      if (idx > dots.length - 1) idx = dots.length - 1;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === idx);
      }
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(setActive); }
    wrapper.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    setActive();
  }
  function initAll() {
    document.querySelectorAll('.ngo-gallery').forEach(initDots);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
// CUSTOM:end

// CUSTOM:start — Diapositive vidéo : diapo entière cliquable si un bouton avec lien
// On reprend l'URL du 1er bouton (a.btn[href]) de la diapo et on injecte un lien
// de recouvrement (.ngo-slide-cover) sous le contenu. Le CSS laisse le bouton et
// les liens réels cliquables, tout en rendant le reste de la diapo cliquable.
(function () {
  function enhance(slide) {
    if (slide.dataset.ngoCover) return;
    // 1er bouton avec un vrai lien (href) — sinon on ne fait rien.
    var btn = slide.querySelector('.slide__content a.btn[href]');
    if (!btn) return;
    var href = btn.getAttribute('href');
    if (!href) return;

    slide.dataset.ngoCover = '1';
    var cover = document.createElement('a');
    cover.className = 'ngo-slide-cover';
    cover.href = href;
    cover.setAttribute('aria-hidden', 'true'); // évite un doublon pour les lecteurs d'écran
    cover.setAttribute('tabindex', '-1');       // le vrai bouton reste la cible clavier
    if (btn.target) cover.target = btn.target;
    if (btn.hasAttribute('rel')) cover.setAttribute('rel', btn.getAttribute('rel'));
    slide.insertBefore(cover, slide.firstChild);
  }

  function scan() {
    document.querySelectorAll('.ngo-video-slide').forEach(enhance);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  // Swiper peut cloner des diapos (mode boucle) → re-scan après init/rendu complet.
  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', scan);
})();
// CUSTOM:end

// CUSTOM:start — Header N'GO transparent : expose la hauteur de la barre d'annonce
// pour que le hero plein écran remonte aussi sous elle (vrai plein écran jusqu'en haut).
// Le reste de la transparence est 100% CSS (cf. sections/header-ngo.liquid).
// Ne fait rien si le header transparent N'GO n'est pas actif.
(function () {
  function update() {
    if (!document.querySelector('.header--ngo-overlay')) return;
    var bar = document.querySelector('.announcement-bar');
    var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--ngo-announce-h', h + 'px');
  }
  if (document.readyState !== 'loading') update();
  else document.addEventListener('DOMContentLoaded', update);
  window.addEventListener('load', update);
  window.addEventListener('resize', update, { passive: true });
})();
// CUSTOM:end

// CUSTOM:start — Header N'GO transparent : marqueur fiable "haut de page" (body.ngo-header-top)
// La transparence ne doit s'appliquer QU'À scrollY 0. On ne se fie pas à .header-scrolled (natif),
// qui n'est pas encore posé au refresh quand le navigateur restaure le scroll APRÈS l'init du
// header → le header apparaissait transparent à tort. Ici on met à jour le marqueur sur load
// (après restauration du scroll), scroll, resize et pageshow (retour bfcache).
(function () {
  function atTop() {
    return (window.scrollY || document.documentElement.scrollTop || 0) <= 1;
  }
  function update() {
    if (!document.querySelector('.header--ngo-overlay')) {
      document.body.classList.remove('ngo-header-top');
      return;
    }
    document.body.classList.toggle('ngo-header-top', atTop());
  }
  if (document.readyState !== 'loading') update();
  else document.addEventListener('DOMContentLoaded', update);
  window.addEventListener('load', update);
  window.addEventListener('pageshow', update);
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
})();
// CUSTOM:end

// CUSTOM:start — Option de langue externe (DE → ngo-shoes.de)
// Le marché Allemagne ayant son propre domaine, la locale "de" n'est plus publiée sur
// le domaine principal : le formulaire 'localization' la rejetterait. Les snippets
// localization-language-header.liquid / localization-form.liquid injectent donc une
// option dont la value est "ngo-external:<url>". On l'intercepte en phase de CAPTURE
// (donc avant le handler natif on:change="/changeLanguage" posé sur le <select>) pour
// annuler la soumission du formulaire et rediriger vers le domaine dédié.
(function () {
  document.addEventListener(
    'change',
    function (event) {
      var select = event.target;
      if (!select || select.name !== 'language_code') return;
      var value = select.value || '';
      if (value.indexOf('ngo-external:') !== 0) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      window.location.href = value.slice('ngo-external:'.length);
    },
    true // capture
  );
})();
// CUSTOM:end

// CUSTOM:start — Filtres collection : choisir une pointure active automatiquement « En stock »
// Sans ça, filtrer sur 42 affiche aussi les modèles dont la 42 est épuisée.
// On complète les paramètres construits par assets/facets.js sans modifier ce fichier.
(function() {
  var AVAILABILITY = 'filter.v.availability';
  var POINTURE = 'filter.v.option.pointure';

  function forceAvailability(params) {
    if (!params.has(POINTURE)) return params;
    params.delete(AVAILABILITY);
    params.append(AVAILABILITY, '1');
    return params;
  }

  customElements.whenDefined('facets-form-component').then(function() {
    var proto = customElements.get('facets-form-component').prototype;

    // Cases cochées, tri, prix : tout passe par createURLParameters
    var originalCreate = proto.createURLParameters;
    proto.createURLParameters = function() {
      return forceAvailability(originalCreate.apply(this, arguments));
    };

    // Retrait d'un filtre actif (pastilles « × ») : l'URL est fournie toute faite
    var originalByURL = proto.updateFiltersByURL;
    proto.updateFiltersByURL = function(url) {
      var parsed = new URL(url, window.location.origin);
      forceAvailability(parsed.searchParams);
      return originalByURL.call(this, parsed.pathname + parsed.search + parsed.hash);
    };
  });
})();
// CUSTOM:end

// CUSTOM:start — Panier : changement du pays de livraison (snippets/free-shipping-goal-custom.liquid)
// Enregistre le pays choisi dans l'attribut caché `_ngo_shipping_country` du panier,
// puis re-rend les sections panier (même mécanique que assets/gift-wrapping.js).
// Le marché Shopify (devise, pays du checkout) n'est pas modifié.
document.addEventListener('change', async function(e) {
  var select = e.target.closest('.ngo-shipping-country__select');
  if (!select) return;
  var wrapper = select.closest('.ngo-shipping-country');
  if (wrapper) wrapper.classList.add('is-loading');

  var ids = [];
  document.querySelectorAll('cart-items-component').forEach(function(el) {
    if (el.dataset.sectionId && ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
  });

  try {
    var res = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: { _ngo_shipping_country: select.value },
        sections: ids.join(','),
        sections_url: window.location.pathname
      })
    });
    var cart = await res.json();
    if (!cart.sections) throw new Error('sections manquantes');
    var renderer = await import('@theme/section-renderer');
    for (var id of Object.keys(cart.sections)) {
      if (cart.sections[id]) await renderer.morphSection(id, cart.sections[id]);
    }
  } catch (err) {
    console.error('[NGO] pays de livraison', err);
    window.location.reload();
  } finally {
    if (wrapper) wrapper.classList.remove('is-loading');
  }
});
// CUSTOM:end

// CUSTOM:start — Cross-sell livraison offerte : clic sur la carte = achat rapide (snippets/ngo-cross-sell.liquid)
// Le picto d'achat rapide est masqué en CSS ; on déclenche son bouton (caché) au clic sur la carte :
//   - 1 variante → ajout direct au panier
//   - plusieurs variantes → ouverture du choix d'options (achat rapide natif)
document.addEventListener('click', function(e) {
  // Ignore le clic simulé par button.click() ci-dessous : sinon preventDefault annule le submit (produit à 1 variante)
  if (!e.isTrusted) return;
  var item = e.target.closest('.ngo-xsell__item');
  if (!item) return;

  e.preventDefault();
  e.stopPropagation();

  var quickAdd = item.querySelector('quick-add-component');
  if (!quickAdd) return;

  var button = quickAdd.dataset.quickAddButton === 'add'
    ? quickAdd.querySelector('form[data-type="add-to-cart-form"] button[type="submit"]')
    : quickAdd.querySelector('.quick-add__button--choose');
  if (!button || button.disabled) return;

  item.classList.add('is-loading');
  var restore = function() { item.classList.remove('is-loading'); };
  document.addEventListener('cart:update', restore, { once: true });
  setTimeout(restore, 3000);

  button.click();
}, true);
// CUSTOM:end

// CUSTOM:start — Ethikdo : textes alternatifs des logos du bouton injecté par le plugin tiers (layout/theme.liquid)
(function() {
  var ALTS = {
    'ethikdo-logo': "éthi'Kdo",
    'ethikpay-logo': 'ethikpay'
  };
  var SELECTOR = 'img.ethikdo-logo:not([alt]), img.ethikpay-logo:not([alt])';

  function addAlts(root) {
    var imgs = root.matches && root.matches(SELECTOR) ? [root] : root.querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(imgs, function(img) {
      img.alt = img.classList.contains('ethikpay-logo') ? ALTS['ethikpay-logo'] : ALTS['ethikdo-logo'];
    });
  }

  // Le plugin (ré)injecte le bouton à chaque rendu du panier : on observe les ajouts au DOM
  new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) addAlts(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  addAlts(document);
})();
// CUSTOM:end

// CUSTOM:start — Fiche produit : aucune taille présélectionnée à l'arrivée
// Le script inline de snippets/variant-main-picker.liquid décoche la taille et pose
// data-ngo-size-pending sur le variant-picker. Tant qu'aucune taille n'est choisie :
// boutons « Choisir une taille » (clic = mise en évidence des tailles, pas d'ajout),
// paiement express masqué. Au premier choix, le fonctionnement natif reprend la main.
(function () {
  var picker = document.querySelector('variant-picker[data-ngo-size-pending]');
  if (!picker) return;

  var productId = picker.getAttribute('data-product-id');
  var label = picker.getAttribute('data-ngo-size-label') || '';
  var sizeOption = picker.querySelector('.ngo-size-option');
  var sizeError = sizeOption && sizeOption.querySelector('.ngo-size-error');
  var pfc = document.querySelector('product-form-component[data-product-id="' + productId + '"]');
  var form = pfc && pfc.querySelector('form[data-type="add-to-cart-form"]');
  var idInput = form && form.querySelector('input[name="id"]');
  var atc = form && form.querySelector('[ref="addToCartButton"]');
  var atcText = atc && atc.querySelector('.add-to-cart-text__content');
  var accelerated = pfc && pfc.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
  var sticky = document.querySelector('sticky-add-to-cart[data-product-id="' + productId + '"]');
  var stickyBtn = sticky && sticky.querySelector('.sticky-add-to-cart__button');
  var stickyText = sticky && sticky.querySelector('[ref="addToCartText"]');
  var stickyVariant = sticky && sticky.querySelector('.sticky-add-to-cart__variant');

  function isPending() {
    return picker.hasAttribute('data-ngo-size-pending');
  }

  // Ramène le client sur les tailles et les fait ressortir brièvement
  function showSizes(e) {
    if (!isPending()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!sizeOption) return;
    // État « taille manquante » : message + contour, jusqu'au choix d'une taille
    sizeOption.classList.add('ngo-size-missing');
    if (sizeError) sizeError.textContent = sizeError.getAttribute('data-message') || '';
    sizeOption.scrollIntoView({ behavior: 'smooth', block: 'center' });
    sizeOption.classList.remove('ngo-size-attention');
    void sizeOption.offsetWidth; // relance l'animation
    sizeOption.classList.add('ngo-size-attention');
    var first = sizeOption.querySelector('input[type="radio"]:not([aria-disabled="true"])');
    if (first) first.focus({ preventScroll: true });
  }

  // État « taille à choisir » (bouton laissé tel quel si le produit est entièrement épuisé)
  var soldOut = atc && atc.disabled;
  var atcAriaLabel = atc && atc.getAttribute('aria-label');
  if (idInput) idInput.value = '';
  if (atcText && !soldOut) atcText.textContent = label;
  if (atc && !soldOut) atc.setAttribute('aria-label', label);
  if (accelerated) accelerated.setAttribute('hidden', 'true');
  if (stickyText && !soldOut) stickyText.textContent = label;
  if (stickyVariant) stickyVariant.textContent = '';
  if (sizeOption) {
    sizeOption.addEventListener('animationend', function () {
      sizeOption.classList.remove('ngo-size-attention');
    });
  }

  if (atc) atc.addEventListener('click', showSizes, true);
  if (stickyBtn) stickyBtn.addEventListener('click', showSizes, true);
  // Filet de sécurité (touche Entrée…) : capture sur window, avant les autres écouteurs de submit
  window.addEventListener('submit', function (e) {
    if (e.target === form) showSizes(e);
  }, true);

  // Premier choix : le thème met à jour bouton, variante et sticky (VariantUpdateEvent)
  picker.addEventListener('change', function () {
    if (!isPending()) return;
    picker.removeAttribute('data-ngo-size-pending');
    if (sizeOption) sizeOption.classList.remove('ngo-size-attention', 'ngo-size-missing');
    if (sizeError) sizeError.textContent = '';
    if (atc && atcAriaLabel) atc.setAttribute('aria-label', atcAriaLabel);
    if (stickyText && stickyBtn) {
      stickyText.textContent = stickyBtn.getAttribute('data-add-to-cart-text') || stickyText.textContent;
    }
  }, true);
})();
// CUSTOM:end

// CUSTOM:start — B2B : prix HT conservés au changement de variante
// product-price.js (natif) réécrit le prix en JS depuis les données brutes de la variante
// (catalogue B2B saisi en TTC) et retire le suffixe « HT ». On intercepte l'événement
// « price:update-optimistic » en phase de capture (avant le handler natif) pour lui passer
// des prix HT, puis on remet le suffixe. Infos B2B : window.NGO_B2B (layout/theme.liquid).
(function () {
  var b2b = window.NGO_B2B;
  if (!b2b) return;

  var divisor = 1 + (Number(b2b.vatRate) || 0) / 100;
  var toHt = function (cents) {
    return typeof cents === 'number' && b2b.catalogTtc ? Math.round(cents / divisor) : cents;
  };

  document.addEventListener(
    'price:update-optimistic',
    function (event) {
      var detail = event.detail;
      if (!detail || !detail.variant) return;

      if (b2b.catalogTtc && !detail.__ngoHt) {
        var v = Object.assign({}, detail.variant);
        v.price = toHt(v.price);
        if (v.compare_at_price) v.compare_at_price = toHt(v.compare_at_price);
        if (v.unit_price) v.unit_price = toHt(v.unit_price);
        detail.variant = v;
        detail.__ngoHt = true;
      }

      if (!b2b.suffix) return;
      var container = event.target;
      // Après le handler natif (synchrone) : on remet le suffixe retiré par textContent
      queueMicrotask(function () {
        container.querySelectorAll('.price__regular .price, .price__sale .price').forEach(function (el) {
          if (el.querySelector('.ngo-b2b-price-suffix')) return;
          var span = document.createElement('span');
          span.className = 'ngo-b2b-price-suffix';
          span.textContent = b2b.suffix;
          el.appendChild(document.createTextNode(' '));
          el.appendChild(span);
        });
      });
    },
    true
  );
})();
// CUSTOM:end
